import MediaplanListContainer from './MediaPlanListContainer';

export default MediaplanListContainer;
